/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StudyTypeEnum } from './studyTypeEnum';
import { TeacherActivityActivityTypeEnum } from './teacherActivityActivityTypeEnum';

export interface TeacherActivityCreate { 
    title: string;
    activityType: TeacherActivityActivityTypeEnum;
    dateStart: string;
    dateEnd: string;
    hourTime: number;
    studyType: StudyTypeEnum;
    price?: string;
    /**
     * Zda si pedagog aktivitu platil ze svých prostředků.
     */
    selfPayer?: boolean;
    organizer?: string;
    organizerWebsite?: string;
    lector?: string;
}